/**
* Each component receives the variables explained below
*
* @param {HTMLElement} el - Component's main DOM element
* @param {Object} params - Params to be used
*/

$('[name="places"]').mask('0000');
$('[name=action_date]').mask('00/00/0000');
$('[name=action_start_time]').mask('00:00');
$('[name=action_end_time]').mask('00:00');

var upload = {
    init: function($wrapper, params) {

        var defaults = {
            crop: true,
            resize: true,
        };

        params = $.extend({}, defaults, params);
        var $btnRemove = $wrapper.find('.btn-remove');
        var $btnSubmit = $wrapper.find('.btn-upload');
        var $load      = $wrapper.find('.load');

        new Dropzone($wrapper.get(0), {
            headers: {'X-CSRF-TOKEN': $(document).find('meta[name="csrf-token"]').attr('content')},
            url: base + '/upload',
            params: {
                "content_type": params.content_type,
                "w": params.w,
                "h": params.h,
                "crop": params.crop,
                "resize": params.resize,
            },
            clickable: $btnSubmit.get(0),
            uploadMultiple: true,
            paramName: 'files',
            acceptedFiles: '.jpg, .jpeg, .png, .gif',
            init: function() {
                this.on('addedfile', function(file) {
                    $wrapper.find('.dz-preview').remove();
                    $load.show();
                    $btnSubmit.attr('disabled', true);
                });
                this.on('sendingmultiple', function(file, xhr, formData) {
                    // $wrapper.find('.progress-group').show();
                });
                this.on('totaluploadprogress', function(progress) {

                });
                this.on('successmultiple', function(file, res) {

                    if(res.error) {
                        alert(res.message);
                    } else {
                        $load.hide();

                        $(res).each(function(index, file) {
                            $wrapper.find('input').val(file.file_item_name);
                            $wrapper.find('.preview img').attr('src', file.file_item_public_url);
                        });

                        $wrapper.find('.upload-btn-wrapper').hide();
                        $wrapper.find('.preview').show();
                    }
                });
                this.on('completemultiple', function() {
                    $btnSubmit.attr('disabled', false);
                    this.removeAllFiles(true);
                })
            }
        });

        $btnRemove.on('click', function(e) {
            e.preventDefault();
            $wrapper.find('input').val('');
            $wrapper.find('.preview img').attr('src', '');
            $wrapper.find('.preview').hide();
            $wrapper.find('.load').hide();
            $wrapper.find('.upload-btn-wrapper').show();
        });

        $btnSubmit.on('click', function(e) {
            e.preventDefault();
        });
    }
};

var txts = document.getElementsByTagName('textarea');

for(var i = 0, l = txts.length; i < l; i++) {
    if(/^[0-9]+$/.test(txts[i].getAttribute("maxlength"))) {
        var func = function() {
            var len = parseInt(this.getAttribute("maxlength"), 10);

            if(this.value.length > len) {
                alert('Maximum length exceeded: ' + len);
                this.value = this.value.substr(0, len);
                return false;
            }
        }

        txts[i].onkeyup = func;
        txts[i].onblur = func;
    }
};

upload.init($('.upload-wrapper-main'), {content_type: 'actions', w: 300, h: 200, crop: true, resize: true });

// $('[name="tags[]"]').select2({
//     "noResults": function() {
//         return "Nenhum resultado encontrado";
//     },
//     escapeMarkup: function (markup) {
//         return markup;
//     },
//     multiple: true,
// });

$('select[name="state"]').on('change', function(e) {
    e.preventDefault();

    var $select = $(this);
    var $selectCities = $('select[name="city_id"]');

    $selectCities.find('option').remove();
    $selectCities.append('<option value=""></option>');

    if($select.val() != '') {
        $.post(base + '/api/get-cities', {uf: $select.val()}, function(response) {
            $.each(response, function(index, data) {
                $selectCities.append('<option value="'+data.id+'">'+data.name+'</option>');
            });
        }, 'json');
    }
});